export const GET_TOTAL_LOAN_AMT_LEFT_REQUEST = 'GET_TOTAL_LOAN_AMT_LEFT_REQUEST'
export const GET_TOTAL_LOAN_AMT_LEFT_SUCCESS = 'GET_TOTAL_LOAN_AMT_LEFT_SUCCESS'
export const GET_TOTAL_LOAN_AMT_LEFT_FAILURE = 'GET_TOTAL_LOAN_AMT_LEFT_FAILURE'
